import { Component, EventEmitter, Input, Output, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'

/** Banco editable de chips para atributos que crecen durante la captura. */
@Component({
  selector: 'app-banco-chips',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './banco-chips.html',
})
export class BancoChipsComponent {
  private static siguienteId = 0

  @Input({ required: true }) banco: string[] = []
  @Input({ required: true }) seleccionados: string[] = []
  @Input({ required: true }) multiple = false
  @Input({ required: true }) variante: 'color' | 'tipo' = 'color'
  @Output() cambiar = new EventEmitter<string[]>()
  @Input() onAgregarAlBanco?: (nombre: string) => void
  /** Si existe, permitimos borrar chips del banco. */
  @Input() onEliminarDelBanco?: (nombre: string) => void
  /** Protegemos valores base que se pueden seleccionar, pero no borrar. */
  @Input() sinBorrar?: string[]

  readonly inputId = `banco-chips-nuevo-${BancoChipsComponent.siguienteId++}`
  readonly nuevo = signal('')

  get claseActivo(): string {
    return this.variante === 'tipo'
      ? 'bg-[var(--sage)] text-white border-[var(--sage)]'
      : 'bg-[var(--ink)] text-white border-[var(--ink)]'
  }

  claseChip(nombre: string): string {
    const base = 'text-[12px] px-3 py-1.5 rounded-full border '
    return base + (this.seleccionados.includes(nombre) ? this.claseActivo : 'border-[var(--border)] text-[var(--muted)] bg-[var(--surface)]')
  }

  muestraX(nombre: string): boolean {
    return Boolean(this.onEliminarDelBanco) && !this.sinBorrar?.includes(nombre)
  }

  alternar(nombre: string): void {
    if (this.multiple) {
      this.cambiar.emit(
        this.seleccionados.includes(nombre) ? this.seleccionados.filter((n) => n !== nombre) : [...this.seleccionados, nombre],
      )
    } else {
      this.cambiar.emit(this.seleccionados.includes(nombre) ? [] : [nombre])
    }
  }

  eliminarDelBanco(e: Event, nombre: string): void {
    e.stopPropagation()
    this.onEliminarDelBanco?.(nombre)
  }

  agregarNuevo(): void {
    const limpio = this.nuevo().trim()
    if (!limpio) return
    if (!this.onAgregarAlBanco) return
    if (!this.banco.includes(limpio)) this.onAgregarAlBanco(limpio)
    this.alternar(limpio)
    this.nuevo.set('')
  }

  alPresionarTecla(e: KeyboardEvent): void {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.agregarNuevo()
    }
  }
}
